import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-cash-closing-item',
  templateUrl: './cash-closing-item.component.html',
  styleUrls: ['./cash-closing-item.component.scss'],
  standalone: false
})
export class CashClosingItemComponent {
  @Input() title!: string;
  @Input() data!: number | string | null;

  @Input() isCurrency: boolean = true;
  @Input() highlight: boolean = false;
}
